import type { Asset } from '@schibsted-svp/svp-api-types';

import { resolveTitleOverride } from '../utils/titleOverride';

import { useConfig } from './ConfigProvider';
import { usePlayer } from './PlayerProvider';

/**
 * Returns `ui.titleOverride` only for the asset the player was configured
 * with (`id` / `asset` in the player config), never for play-next assets.
 */
export const useTitleOverride = (asset?: Pick<Asset, 'id'>) => {
  const { ui } = useConfig();
  const player = usePlayer();

  return resolveTitleOverride(
    player.getRawConfig(),
    asset?.id,
    ui?.titleOverride
  );
};
